import { requestApi } from "../../utils/requests";
import { AJAX_COMPLETE } from "../../utils/requests/constants";

function handleSubmit(event) {
  event.preventDefault();

  const form = event.target;

  // eslint-disable-next-line no-undef
  const formData = new FormData(form);

  requestApi({
    method: event.target.method,
    route: event.target.action,
    data: formData,
    formData: true,
  }).then((response) => {
    if (response && response.status >= 200 && response.status < 300) {
      document.querySelector("[data-cookies-advice]").classList.add("d-none");
      document.querySelector("#cookies-preferences-modal").classList.add("d-none");
      // eslint-disable-next-line no-undef
      document.dispatchEvent(new Event(AJAX_COMPLETE));
    }
  });
}

function addListerToCookieForms() {
  const cookiesForms = document.querySelectorAll(".cookie-advice-form");
  cookiesForms.forEach((form) => {
    form.addEventListener("submit", handleSubmit);
  });
}

document.addEventListener("modal.cookie_preferences.open", addListerToCookieForms);

addListerToCookieForms();
